import React, { useEffect, useState, Component } from 'react';
import { useAdminAuth } from '../../context/AdminAuthContext';
import AdminSidebar from '../../components/admin/AdminSidebar';
import AdminHeader from '../../components/admin/AdminHeader';
import { BuildingIcon, SearchIcon, FilterIcon, ChevronDownIcon, RefreshCwIcon, DownloadIcon, PlusIcon, EyeIcon, EditIcon, TrashIcon, MoreHorizontalIcon, CheckCircleIcon, XCircleIcon, AlertCircleIcon, ArrowUpIcon, ArrowDownIcon, CalendarIcon, ClockIcon, UserIcon, CheckIcon, XIcon, ChevronLeftIcon, ChevronRightIcon, HelpCircleIcon, InfoIcon, AlertTriangleIcon, FileIcon, SendIcon, ArrowRightIcon, MessageSquareIcon, DollarSignIcon, TagIcon, FolderIcon, BarChartIcon, PaperclipIcon, ListIcon, BellIcon, MapPinIcon, HashIcon, CreditCardIcon, FileTextIcon, ShieldIcon, ExternalLinkIcon, PrinterIcon, ArrowLeftIcon, ClipboardIcon, UserCheckIcon, MessageCircleIcon, PhoneIcon, MailIcon, ThumbsUpIcon, ThumbsDownIcon, Share2Icon, GlobeIcon, LockIcon, UnlockIcon, Settings2Icon, LayoutIcon, UsersIcon, UploadIcon, ImageIcon, GridIcon, StarIcon, TrendingUpIcon, AwardIcon, LayersIcon, LinkIcon, PenToolIcon, ZapIcon } from 'lucide-react';
// Mock data generator for MDAs
const generateMockMDAs = (count: number) => {
  const mdaTypes = ['Ministry', 'Department', 'Agency', 'Commission', 'Authority', 'Board'];
  const sectors = ['Finance', 'Education', 'Health', 'Agriculture', 'Transportation', 'Commerce', 'Environment', 'Technology', 'Energy', 'Labor', 'Justice', 'Defense', 'Foreign Affairs', 'Housing', 'Tourism', 'Culture', 'Sports', 'Information', 'Social Welfare', 'Planning'];
  const statuses = ['Active', 'Inactive', 'Under Review', 'Pending Approval'];
  const mockData = [];
  const now = new Date();
  // Pre-defined MDAs for consistency
  const predefinedMDAs = [{
    name: 'Ministry of Finance',
    type: 'Ministry',
    sector: 'Finance',
    status: 'Active',
    services: 15,
    users: 120,
    revenue: 1250000
  }, {
    name: 'Ministry of Education',
    type: 'Ministry',
    sector: 'Education',
    status: 'Active',
    services: 12,
    users: 95,
    revenue: 850000
  }, {
    name: 'Ministry of Health',
    type: 'Ministry',
    sector: 'Health',
    status: 'Active',
    services: 18,
    users: 150,
    revenue: 1100000
  }, {
    name: 'Ministry of Commerce and Industry',
    type: 'Ministry',
    sector: 'Commerce',
    status: 'Active',
    services: 14,
    users: 85,
    revenue: 950000
  }, {
    name: 'Ministry of Lands and Surveys',
    type: 'Ministry',
    sector: 'Housing',
    status: 'Active',
    services: 10,
    users: 75,
    revenue: 1050000
  }, {
    name: 'Federal Road Safety Commission',
    type: 'Commission',
    sector: 'Transportation',
    status: 'Active',
    services: 8,
    users: 65,
    revenue: 750000
  }];
  // Add predefined MDAs first
  for (let i = 0; i < predefinedMDAs.length; i++) {
    const mda = predefinedMDAs[i];
    const createdDate = new Date(now);
    createdDate.setMonth(now.getMonth() - Math.floor(Math.random() * 36)); // Random date within the last 3 years
    const lastUpdateDate = new Date(createdDate);
    lastUpdateDate.setDate(createdDate.getDate() + Math.floor(Math.random() * (now.getTime() - createdDate.getTime()) / (1000 * 60 * 60 * 24)));
    // Generate random growth rates
    const userGrowth = Math.random() > 0.7 ? -Math.floor(Math.random() * 10) : Math.floor(Math.random() * 25);
    const revenueGrowth = Math.random() > 0.7 ? -Math.floor(Math.random() * 10) : Math.floor(Math.random() * 30);
    const serviceGrowth = Math.random() > 0.8 ? -Math.floor(Math.random() * 5) : Math.floor(Math.random() * 15);
    // Generate random contact information
    const email = `info@${mda.name.toLowerCase().replace(/\s+/g, '').replace(/,/g, '')}.gov.ng`;
    const phone = `+234${Math.floor(Math.random() * 10000000000).toString().padStart(10, '0')}`;
    const website = `https://www.${mda.name.toLowerCase().replace(/\s+/g, '').replace(/,/g, '')}.gov.ng`;
    const address = `${Math.floor(Math.random() * 100) + 1} ${['Main', 'Central', 'Government', 'Federal', 'State'][Math.floor(Math.random() * 5)]} Avenue, Abuja`;
    // Generate random admin users
    const adminUsers = [];
    const adminCount = Math.floor(Math.random() * 3) + 2; // 2-4 admin users
    for (let j = 0; j < adminCount; j++) {
      const firstName = ['John', 'Jane', 'Michael', 'Sarah', 'David', 'Emily', 'Robert', 'Jennifer', 'Chinua', 'Ngozi', 'Oluwaseun', 'Chioma', 'Adebayo', 'Folake', 'Emeka', 'Amara', 'Ibrahim', 'Fatima', 'Mohammed', 'Aisha', 'Yusuf', 'Zainab', 'Aliyu'][Math.floor(Math.random() * 23)];
      const lastName = ['Smith', 'Johnson', 'Williams', 'Jones', 'Brown', 'Davis', 'Miller', 'Wilson', 'Okonkwo', 'Adeyemi', 'Okafor', 'Nwachukwu', 'Eze', 'Okoro', 'Afolayan', 'Adebisi', 'Mohammed', 'Ibrahim', 'Yusuf', 'Abdullahi', 'Bello', 'Musa', 'Abubakar'][Math.floor(Math.random() * 23)];
      const role = j === 0 ? 'MDA Admin' : 'MDA Staff';
      const adminEmail = `${firstName.toLowerCase()}.${lastName.toLowerCase()}@${mda.name.toLowerCase().replace(/\s+/g, '').replace(/,/g, '')}.gov.ng`;
      adminUsers.push({
        id: `user-${i}-${j}`,
        name: `${firstName} ${lastName}`,
        email: adminEmail,
        role: role,
        status: Math.random() > 0.1 ? 'Active' : 'Inactive',
        lastLogin: new Date(now.getTime() - Math.floor(Math.random() * 7 * 24 * 60 * 60 * 1000)).toISOString() // Within the last week
      });
    }
    // Generate random services
    const services = [];
    for (let j = 0; j < mda.services; j++) {
      const serviceNames = {
        Finance: ['Tax Clearance Certificate', 'Business Registration', 'Financial Statement Filing', 'Tax ID Application', 'Business Permit Renewal'],
        Education: ['School Enrollment', 'Transcript Request', 'Certificate Verification', 'Scholarship Application', 'Teacher Registration'],
        Health: ['Health Insurance Registration', 'Hospital Appointment', 'Medical License', 'Birth Certificate', 'Vaccination Record'],
        Commerce: ['Business Registration', 'Trade License', 'Export Permit', 'Market Stall Allocation', 'Consumer Complaint'],
        Housing: ['Land Documentation', 'Building Permit', 'Property Registration', 'Certificate of Occupancy', 'Survey Plan Approval'],
        Transportation: ["Driver's License Renewal", 'Vehicle Registration', 'Number Plate Issuance', 'Road Worthiness Certificate', 'Change of Ownership']
      };
      const sectorServiceNames = serviceNames[mda.sector as keyof typeof serviceNames] || ['Service Application', 'License Renewal', 'Certificate Request', 'Permit Application', 'Registration'];
      const serviceName = sectorServiceNames[j % sectorServiceNames.length];
      const fee = Math.floor(Math.random() * 50000) + 1000;
      const processingTime = Math.floor(Math.random() * 14) + 1; // 1-14 days
      services.push({
        id: `service-${i}-${j}`,
        name: serviceName,
        description: `${serviceName} processing and issuance service`,
        fee: fee,
        processingTime: processingTime,
        status: Math.random() > 0.1 ? 'Active' : 'Under Review',
        applications: Math.floor(Math.random() * 500) + 50,
        revenue: fee * (Math.floor(Math.random() * 500) + 50)
      });
    }
    // Generate random documents
    const documents = [];
    const documentCount = Math.floor(Math.random() * 5) + 3; // 3-7 documents
    const documentTypes = ['Policy Document', 'Guideline', 'Procedure Manual', 'Form Template', 'Brochure', 'Annual Report', 'Charter'];
    for (let j = 0; j < documentCount; j++) {
      const documentType = documentTypes[Math.floor(Math.random() * documentTypes.length)];
      const uploadDate = new Date(lastUpdateDate);
      uploadDate.setDate(lastUpdateDate.getDate() - Math.floor(Math.random() * 90)); // Within the last 90 days
      documents.push({
        id: `doc-${i}-${j}`,
        name: `${mda.name} ${documentType}`,
        type: documentType,
        size: `${Math.floor(Math.random() * 10) + 1}MB`,
        uploadedAt: uploadDate.toISOString(),
        uploadedBy: adminUsers[Math.floor(Math.random() * adminUsers.length)].name
      });
    }
    // Generate KPIs
    const kpis = [{
      name: 'Application Processing Time',
      value: `${Math.floor(Math.random() * 5) + 1} days`,
      change: Math.random() > 0.6 ? -Math.floor(Math.random() * 20) : Math.floor(Math.random() * 10),
      target: `${Math.floor(Math.random() * 3) + 1} days`
    }, {
      name: 'User Satisfaction',
      value: `${Math.floor(Math.random() * 20) + 80}%`,
      change: Math.random() > 0.3 ? Math.floor(Math.random() * 10) : -Math.floor(Math.random() * 5),
      target: '95%'
    }, {
      name: 'Service Availability',
      value: `${Math.floor(Math.random() * 5) + 95}%`,
      change: Math.random() > 0.7 ? -Math.floor(Math.random() * 3) : Math.floor(Math.random() * 2),
      target: '99.9%'
    }, {
      name: 'Digital Adoption',
      value: `${Math.floor(Math.random() * 30) + 70}%`,
      change: Math.floor(Math.random() * 15),
      target: '100%'
    }];
    mockData.push({
      id: `mda-${i}`,
      name: mda.name,
      type: mda.type,
      sector: mda.sector,
      status: mda.status,
      createdAt: createdDate.toISOString(),
      lastUpdateAt: lastUpdateDate.toISOString(),
      services: services,
      serviceCount: mda.services,
      serviceGrowth: serviceGrowth,
      userCount: mda.users,
      userGrowth: userGrowth,
      revenue: mda.revenue,
      revenueGrowth: revenueGrowth,
      adminUsers: adminUsers,
      contactInfo: {
        email: email,
        phone: phone,
        website: website,
        address: address
      },
      documents: documents,
      kpis: kpis,
      logo: `https://ui-avatars.com/api/?name=${encodeURIComponent(mda.name)}&background=random&color=fff&size=128`
    });
  }
  // Generate remaining random MDAs
  for (let i = predefinedMDAs.length; i < count; i++) {
    const type = mdaTypes[Math.floor(Math.random() * mdaTypes.length)];
    const sector = sectors[Math.floor(Math.random() * sectors.length)];
    // Generate a random name based on type and sector
    let name;
    if (type === 'Ministry') {
      name = `Ministry of ${sector}`;
    } else if (type === 'Department') {
      name = `Department of ${sector}`;
    } else {
      name = `${sector} ${type}`;
    }
    // Avoid duplicate names
    if (mockData.some(mda => mda.name === name)) {
      if (type === 'Ministry') {
        name = `Ministry of ${sector} and Regional Development`;
      } else if (type === 'Department') {
        name = `Department of ${sector} Services`;
      } else {
        name = `National ${sector} ${type}`;
      }
    }
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const serviceCount = Math.floor(Math.random() * 15) + 5; // 5-20 services
    const userCount = Math.floor(Math.random() * 100) + 20; // 20-120 users
    const revenue = (Math.floor(Math.random() * 1000) + 100) * 1000; // 100k-1.1M
    const createdDate = new Date(now);
    createdDate.setMonth(now.getMonth() - Math.floor(Math.random() * 36)); // Random date within the last 3 years
    const lastUpdateDate = new Date(createdDate);
    lastUpdateDate.setDate(createdDate.getDate() + Math.floor(Math.random() * (now.getTime() - createdDate.getTime()) / (1000 * 60 * 60 * 24)));
    // Generate random growth rates
    const userGrowth = Math.random() > 0.7 ? -Math.floor(Math.random() * 10) : Math.floor(Math.random() * 25);
    const revenueGrowth = Math.random() > 0.7 ? -Math.floor(Math.random() * 10) : Math.floor(Math.random() * 30);
    const serviceGrowth = Math.random() > 0.8 ? -Math.floor(Math.random() * 5) : Math.floor(Math.random() * 15);
    // Generate random contact information
    const email = `info@${name.toLowerCase().replace(/\s+/g, '').replace(/,/g, '')}.gov.ng`;
    const phone = `+234${Math.floor(Math.random() * 10000000000).toString().padStart(10, '0')}`;
    const website = `https://www.${name.toLowerCase().replace(/\s+/g, '').replace(/,/g, '')}.gov.ng`;
    const address = `${Math.floor(Math.random() * 100) + 1} ${['Main', 'Central', 'Government', 'Federal', 'State'][Math.floor(Math.random() * 5)]} Avenue, Abuja`;
    // Generate random admin users
    const adminUsers = [];
    const adminCount = Math.floor(Math.random() * 3) + 2; // 2-4 admin users
    for (let j = 0; j < adminCount; j++) {
      const firstName = ['John', 'Jane', 'Michael', 'Sarah', 'David', 'Emily', 'Robert', 'Jennifer', 'Chinua', 'Ngozi', 'Oluwaseun', 'Chioma', 'Adebayo', 'Folake', 'Emeka', 'Amara', 'Ibrahim', 'Fatima', 'Mohammed', 'Aisha', 'Yusuf', 'Zainab', 'Aliyu'][Math.floor(Math.random() * 23)];
      const lastName = ['Smith', 'Johnson', 'Williams', 'Jones', 'Brown', 'Davis', 'Miller', 'Wilson', 'Okonkwo', 'Adeyemi', 'Okafor', 'Nwachukwu', 'Eze', 'Okoro', 'Afolayan', 'Adebisi', 'Mohammed', 'Ibrahim', 'Yusuf', 'Abdullahi', 'Bello', 'Musa', 'Abubakar'][Math.floor(Math.random() * 23)];
      const role = j === 0 ? 'MDA Admin' : 'MDA Staff';
      const adminEmail = `${firstName.toLowerCase()}.${lastName.toLowerCase()}@${name.toLowerCase().replace(/\s+/g, '').replace(/,/g, '')}.gov.ng`;
      adminUsers.push({
        id: `user-${i}-${j}`,
        name: `${firstName} ${lastName}`,
        email: adminEmail,
        role: role,
        status: Math.random() > 0.1 ? 'Active' : 'Inactive',
        lastLogin: new Date(now.getTime() - Math.floor(Math.random() * 7 * 24 * 60 * 60 * 1000)).toISOString() // Within the last week
      });
    }
    // Generate random services
    const services = [];
    for (let j = 0; j < serviceCount; j++) {
      const serviceNames = {
        Finance: ['Tax Clearance Certificate', 'Business Registration', 'Financial Statement Filing', 'Tax ID Application', 'Business Permit Renewal'],
        Education: ['School Enrollment', 'Transcript Request', 'Certificate Verification', 'Scholarship Application', 'Teacher Registration'],
        Health: ['Health Insurance Registration', 'Hospital Appointment', 'Medical License', 'Birth Certificate', 'Vaccination Record'],
        Commerce: ['Business Registration', 'Trade License', 'Export Permit', 'Market Stall Allocation', 'Consumer Complaint'],
        Housing: ['Land Documentation', 'Building Permit', 'Property Registration', 'Certificate of Occupancy', 'Survey Plan Approval'],
        Transportation: ["Driver's License Renewal", 'Vehicle Registration', 'Number Plate Issuance', 'Road Worthiness Certificate', 'Change of Ownership']
      };
      const sectorServiceNames = serviceNames[sector as keyof typeof serviceNames] || ['Service Application', 'License Renewal', 'Certificate Request', 'Permit Application', 'Registration'];
      const serviceName = sectorServiceNames[j % sectorServiceNames.length];
      const fee = Math.floor(Math.random() * 50000) + 1000;
      const processingTime = Math.floor(Math.random() * 14) + 1; // 1-14 days
      services.push({
        id: `service-${i}-${j}`,
        name: serviceName,
        description: `${serviceName} processing and issuance service`,
        fee: fee,
        processingTime: processingTime,
        status: Math.random() > 0.1 ? 'Active' : 'Under Review',
        applications: Math.floor(Math.random() * 500) + 50,
        revenue: fee * (Math.floor(Math.random() * 500) + 50)
      });
    }
    // Generate random documents
    const documents = [];
    const documentCount = Math.floor(Math.random() * 5) + 3; // 3-7 documents
    const documentTypes = ['Policy Document', 'Guideline', 'Procedure Manual', 'Form Template', 'Brochure', 'Annual Report', 'Charter'];
    for (let j = 0; j < documentCount; j++) {
      const documentType = documentTypes[Math.floor(Math.random() * documentTypes.length)];
      const uploadDate = new Date(lastUpdateDate);
      uploadDate.setDate(lastUpdateDate.getDate() - Math.floor(Math.random() * 90)); // Within the last 90 days
      documents.push({
        id: `doc-${i}-${j}`,
        name: `${name} ${documentType}`,
        type: documentType,
        size: `${Math.floor(Math.random() * 10) + 1}MB`,
        uploadedAt: uploadDate.toISOString(),
        uploadedBy: adminUsers[Math.floor(Math.random() * adminUsers.length)].name
      });
    }
    // Generate KPIs
    const kpis = [{
      name: 'Application Processing Time',
      value: `${Math.floor(Math.random() * 5) + 1} days`,
      change: Math.random() > 0.6 ? -Math.floor(Math.random() * 20) : Math.floor(Math.random() * 10),
      target: `${Math.floor(Math.random() * 3) + 1} days`
    }, {
      name: 'User Satisfaction',
      value: `${Math.floor(Math.random() * 20) + 80}%`,
      change: Math.random() > 0.3 ? Math.floor(Math.random() * 10) : -Math.floor(Math.random() * 5),
      target: '95%'
    }, {
      name: 'Service Availability',
      value: `${Math.floor(Math.random() * 5) + 95}%`,
      change: Math.random() > 0.7 ? -Math.floor(Math.random() * 3) : Math.floor(Math.random() * 2),
      target: '99.9%'
    }, {
      name: 'Digital Adoption',
      value: `${Math.floor(Math.random() * 30) + 70}%`,
      change: Math.floor(Math.random() * 15),
      target: '100%'
    }];
    mockData.push({
      id: `mda-${i}`,
      name: name,
      type: type,
      sector: sector,
      status: status,
      createdAt: createdDate.toISOString(),
      lastUpdateAt: lastUpdateDate.toISOString(),
      services: services,
      serviceCount: serviceCount,
      serviceGrowth: serviceGrowth,
      userCount: userCount,
      userGrowth: userGrowth,
      revenue: revenue,
      revenueGrowth: revenueGrowth,
      adminUsers: adminUsers,
      contactInfo: {
        email: email,
        phone: phone,
        website: website,
        address: address
      },
      documents: documents,
      kpis: kpis,
      logo: `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random&color=fff&size=128`
    });
  }
  return mockData;
};
// MDA Type for TypeScript
interface MDA {
  id: string;
  name: string;
  acronym: string;
  description: string;
  logoUrl: string;
  serviceCount: number;
  establishedDate: string;
  status: 'active' | 'inactive';
  website?: string;
  email?: string;
  phone?: string;
  address?: string;
}
const MDAManagement: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [mdas, setMdas] = useState<any[]>([]);
  const [filteredMdas, setFilteredMdas] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [typeFilter, setTypeFilter] = useState('all');
  const [sectorFilter, setSectorFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortOrder, setSortOrder] = useState('name');
  const [selectedMda, setSelectedMda] = useState<string | null>(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [mdaToUpdate, setMdaToUpdate] = useState<any>(null);
  const [mdaToDelete, setMdaToDelete] = useState<string>('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [mdaStats, setMdaStats] = useState({
    total: 0,
    active: 0,
    inactive: 0,
    totalRevenue: '₦0',
    totalServices: 0
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [activeTab, setActiveTab] = useState('overview');
  const {
    hasPermission,
    isSuperAdmin
  } = useAdminAuth();
  const canCreateMda = hasPermission('mdas:create');
  const canUpdateMda = hasPermission('mdas:edit');
  const canDeleteMda = hasPermission('mdas:delete');
  const canExportMdas = hasPermission('mdas:export');
  // Set initial sidebar state based on screen size
  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 1024);
    };
    // Set initial state
    handleResize();
    // Add event listener
    window.addEventListener('resize', handleResize);
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Load MDAs
  useEffect(() => {
    if (!isSuperAdmin()) {
      // Redirect non-super admins or show access denied
      return;
    }
    setIsLoading(true);
    // Simulate API call delay
    setTimeout(() => {
      const allMdas = generateMockMDAs(20);
      setMdas(allMdas);
      setFilteredMdas(allMdas);
      // Calculate MDA stats
      const total = allMdas.length;
      const active = allMdas.filter((a: any) => a.status === 'Active').length;
      const inactive = total - active;
      // Calculate total revenue
      const totalRevenue = allMdas.reduce((sum: number, mda: any) => sum + mda.revenue, 0);
      // Calculate total services
      const totalServices = allMdas.reduce((sum: number, mda: any) => sum + mda.serviceCount, 0);
      setMdaStats({
        total,
        active,
        inactive,
        totalRevenue: `₦${(totalRevenue / 1000000).toFixed(2)}M`,
        totalServices
      });
      setIsLoading(false);
    }, 1000);
  }, [isSuperAdmin]);
  // Apply filters
  useEffect(() => {
    let filtered = [...mdas];
    // Apply type filter
    if (typeFilter !== 'all') {
      filtered = filtered.filter(m => m.type === typeFilter);
    }
    // Apply sector filter
    if (sectorFilter !== 'all') {
      filtered = filtered.filter(m => m.sector === sectorFilter);
    }
    // Apply status filter
    if (statusFilter !== 'all') {
      filtered = filtered.filter(m => m.status === statusFilter);
    }
    // Apply search query
    if (searchQuery.trim() !== '') {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(m => m.name.toLowerCase().includes(query) || m.type.toLowerCase().includes(query) || m.sector.toLowerCase().includes(query) || m.contactInfo.email.toLowerCase().includes(query));
    }
    // Apply sort order
    filtered.sort((a, b) => {
      if (sortOrder === 'name') {
        return a.name.localeCompare(b.name);
      } else if (sortOrder === 'name-desc') {
        return b.name.localeCompare(a.name);
      } else if (sortOrder === 'created') {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
      } else if (sortOrder === 'updated') {
        return new Date(b.lastUpdateAt).getTime() - new Date(a.lastUpdateAt).getTime();
      } else if (sortOrder === 'services') {
        return b.serviceCount - a.serviceCount;
      } else if (sortOrder === 'revenue') {
        return b.revenue - a.revenue;
      }
      return 0;
    });
    setFilteredMdas(filtered);
    setCurrentPage(1); // Reset to first page when filters change
  }, [mdas, searchQuery, typeFilter, sectorFilter, statusFilter, sortOrder]);
  // Toggle sidebar
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  // Toggle dropdown
  const toggleDropdown = (dropdown: string) => {
    if (activeDropdown === dropdown) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdown);
    }
  };
  // View MDA details
  const viewMdaDetails = (mdaId: string) => {
    setSelectedMda(mdaId);
    setActiveTab('overview');
  };
  // Delete MDA
  const deleteMda = (mdaId: string) => {
    setMdaToDelete(mdaId);
    setShowDeleteModal(true);
  };
  // Process delete
  const processDelete = () => {
    if (!mdaToDelete) return;
    setIsProcessing(true);
    // Simulate API call delay
    setTimeout(() => {
      const updatedMdas = mdas.filter(mda => mda.id !== mdaToDelete);
      setMdas(updatedMdas);
      setShowDeleteModal(false);
      setMdaToDelete('');
      setIsProcessing(false);
      // If the deleted MDA was selected, clear the selection
      if (selectedMda === mdaToDelete) {
        setSelectedMda(null);
      }
      // Recalculate MDA stats
      const total = updatedMdas.length;
      const active = updatedMdas.filter((a: any) => a.status === 'Active').length;
      const inactive = total - active;
      // Calculate total revenue
      const totalRevenue = updatedMdas.reduce((sum: number, mda: any) => sum + mda.revenue, 0);
      // Calculate total services
      const totalServices = updatedMdas.reduce((sum: number, mda: any) => sum + mda.serviceCount, 0);
      setMdaStats({
        total,
        active,
        inactive,
        totalRevenue: `₦${(totalRevenue / 1000000).toFixed(2)}M`,
        totalServices
      });
    }, 1000);
  };
  // Update MDA status
  const updateMdaStatus = (mdaId: string, newStatus: string) => {
    const updatedMdas = mdas.map(mda => {
      if (mda.id === mdaId) {
        return {
          ...mda,
          status: newStatus,
          lastUpdateAt: new Date().toISOString()
        };
      }
      return mda;
    });
    setMdas(updatedMdas);
    // Recalculate MDA stats
    const total = updatedMdas.length;
    const active = updatedMdas.filter((a: any) => a.status === 'Active').length;
    const inactive = total - active;
    setMdaStats({
      ...mdaStats,
      total,
      active,
      inactive
    });
    // If the MDA whose status was changed is currently selected, update the selection
    if (selectedMda === mdaId) {
      setSelectedMda(null);
      setTimeout(() => setSelectedMda(mdaId), 100);
    }
  };
  // Refresh MDAs
  const refreshMdas = () => {
    setIsLoading(true);
    // Simulate API call delay
    setTimeout(() => {
      const allMdas = generateMockMDAs(20);
      setMdas(allMdas);
      // Calculate MDA stats
      const total = allMdas.length;
      const active = allMdas.filter((a: any) => a.status === 'Active').length;
      const inactive = total - active;
      // Calculate total revenue
      const totalRevenue = allMdas.reduce((sum: number, mda: any) => sum + mda.revenue, 0);
      // Calculate total services
      const totalServices = allMdas.reduce((sum: number, mda: any) => sum + mda.serviceCount, 0);
      setMdaStats({
        total,
        active,
        inactive,
        totalRevenue: `₦${(totalRevenue / 1000000).toFixed(2)}M`,
        totalServices
      });
      setIsLoading(false);
      setSelectedMda(null);
    }, 1000);
  };
  // Get status badge class
  const getStatusBadgeClass = (status: string) => {
    switch (status) {
      case 'Active':
        return 'bg-green-100 text-green-800';
      case 'Inactive':
        return 'bg-red-100 text-red-800';
      case 'Under Review':
        return 'bg-purple-100 text-purple-800';
      case 'Pending Approval':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  // Get status icon
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'Active':
        return <CheckCircleIcon size={16} className="text-green-600" data-id="element-1931" />;
      case 'Inactive':
        return <XCircleIcon size={16} className="text-red-600" data-id="element-1932" />;
      case 'Under Review':
        return <SearchIcon size={16} className="text-purple-600" data-id="element-1933" />;
      case 'Pending Approval':
        return <ClockIcon size={16} className="text-yellow-600" data-id="element-1934" />;
      default:
        return <InfoIcon size={16} className="text-gray-600" data-id="element-1935" />;
    }
  };
  // Format date
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  // Format date with time
  const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  // Format currency
  const formatCurrency = (amount: number) => {
    return `₦${amount.toLocaleString()}`;
  };
  // Format growth indicator
  const formatGrowth = (growth: number) => {
    if (growth > 0) {
      return <span className="flex items-center text-green-600" data-id="element-1936">
          <ArrowUpIcon size={14} className="mr-1" data-id="element-1937" />
          {growth}%
        </span>;
    } else if (growth < 0) {
      return <span className="flex items-center text-red-600" data-id="element-1938">
          <ArrowDownIcon size={14} className="mr-1" data-id="element-1939" />
          {Math.abs(growth)}%
        </span>;
    } else {
      return <span className="flex items-center text-gray-600" data-id="element-1940">0%</span>;
    }
  };
  // Export MDAs
  const exportMdas = () => {
    // In a real application, this would generate a CSV or Excel file
    alert('MDAs exported successfully');
  };
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMdas.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredMdas.length / itemsPerPage);
  const paginate = (pageNumber: number) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  // Get unique types for filter
  const uniqueTypes = [...new Set(mdas.map(mda => mda.type))];
  // Get unique sectors for filter
  const uniqueSectors = [...new Set(mdas.map(mda => mda.sector))];
  // Access control check
  if (!isSuperAdmin()) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-100" data-id="element-1941">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center" data-id="element-1942">
          <div className="rounded-full bg-red-100 p-3 mx-auto w-16 h-16 flex items-center justify-center mb-4" data-id="element-1943">
            <LockIcon size={24} className="text-red-600" data-id="element-1944" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1945">
            Access Denied
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-1946">
            You do not have permission to access the MDA Management section.
            This area is restricted to Super Administrators only.
          </p>
          <a href="/admin/dashboard" className="inline-block bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition-colors" data-id="element-1947">
            Return to Dashboard
          </a>
        </div>
      </div>;
  }
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-100" data-id="element-1948">
        <div className="flex flex-col items-center" data-id="element-1949">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mb-4" data-id="element-1950"></div>
          <p className="text-gray-600" data-id="element-1951">Loading MDA data...</p>
        </div>
      </div>;
  }
  return <div className="flex h-screen bg-gray-100" data-id="element-1952">
      {/* Sidebar - hidden on mobile unless toggled */}
      <div className={`${isSidebarOpen ? 'block' : 'hidden'} lg:block fixed inset-y-0 left-0 z-50 lg:relative lg:z-0`} data-id="element-1953">
        <AdminSidebar data-id="element-1954" />
      </div>
      {/* Backdrop for mobile sidebar */}
      {isSidebarOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" onClick={() => setIsSidebarOpen(false)} data-id="element-1955"></div>}
      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-1956">
        <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} data-id="element-1957" />
        <main className="flex-1 overflow-y-auto p-4 lg:p-6" data-id="element-1958">
          {/* Page Header */}
          <div className="mb-6" data-id="element-1959">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-1960">MDA Management</h1>
            <p className="text-gray-600 mt-1" data-id="element-1961">
              Manage Ministries, Departments, and Agencies across the platform
            </p>
          </div>
          {/* MDA Stats */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4 mb-6" data-id="element-1962">
            <div className="bg-white rounded-lg shadow p-4" data-id="element-1963">
              <div className="flex justify-between items-start" data-id="element-1964">
                <div data-id="element-1965">
                  <p className="text-sm font-medium text-gray-500" data-id="element-1966">
                    Total MDAs
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1967">
                    {mdaStats.total.toLocaleString()}
                  </p>
                </div>
                <div className="p-2 bg-blue-100 rounded-md" data-id="element-1968">
                  <BuildingIcon size={20} className="text-blue-600" data-id="element-1969" />
                </div>
              </div>
              <div className="mt-2 text-xs text-gray-600" data-id="element-1970">
                <span data-id="element-1971">Platform-wide</span>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow p-4" data-id="element-1972">
              <div className="flex justify-between items-start" data-id="element-1973">
                <div data-id="element-1974">
                  <p className="text-sm font-medium text-gray-500" data-id="element-1975">
                    Active MDAs
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1976">
                    {mdaStats.active.toLocaleString()}
                  </p>
                </div>
                <div className="p-2 bg-green-100 rounded-md" data-id="element-1977">
                  <CheckCircleIcon size={20} className="text-green-600" data-id="element-1978" />
                </div>
              </div>
              <div className="mt-2 text-xs text-gray-600" data-id="element-1979">
                <span data-id="element-1980">
                  {Math.round(mdaStats.active / mdaStats.total * 100)}% of
                  total MDAs
                </span>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow p-4" data-id="element-1981">
              <div className="flex justify-between items-start" data-id="element-1982">
                <div data-id="element-1983">
                  <p className="text-sm font-medium text-gray-500" data-id="element-1984">
                    Total Services
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1985">
                    {mdaStats.totalServices.toLocaleString()}
                  </p>
                </div>
                <div className="p-2 bg-purple-100 rounded-md" data-id="element-1986">
                  <LayersIcon size={20} className="text-purple-600" data-id="element-1987" />
                </div>
              </div>
              <div className="mt-2 flex items-center text-xs text-green-600" data-id="element-1988">
                <ArrowUpIcon size={14} className="mr-1" data-id="element-1989" />
                <span data-id="element-1990">12% from last quarter</span>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow p-4" data-id="element-1991">
              <div className="flex justify-between items-start" data-id="element-1992">
                <div data-id="element-1993">
                  <p className="text-sm font-medium text-gray-500" data-id="element-1994">
                    Total Revenue
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1995">
                    {mdaStats.totalRevenue}
                  </p>
                </div>
                <div className="p-2 bg-green-100 rounded-md" data-id="element-1996">
                  <DollarSignIcon size={20} className="text-green-600" data-id="element-1997" />
                </div>
              </div>
              <div className="mt-2 flex items-center text-xs text-green-600" data-id="element-1998">
                <ArrowUpIcon size={14} className="mr-1" data-id="element-1999" />
                <span data-id="element-2000">8% from last month</span>
              </div>
            </div>
            {/* Quick Actions - Only visible on larger screens */}
            <div className="bg-white rounded-lg shadow p-4 hidden xl:block" data-id="element-2001">
              <p className="text-sm font-medium text-gray-500 mb-3" data-id="element-2002">
                Quick Actions
              </p>
              <div className="space-y-2" data-id="element-2003">
                {canCreateMda && <button onClick={() => setShowCreateModal(true)} className="w-full flex items-center justify-between text-sm px-3 py-2 bg-green-50 text-green-700 rounded-md hover:bg-green-100" data-id="element-2004">
                    <span className="flex items-center" data-id="element-2005">
                      <PlusIcon size={16} className="mr-2" data-id="element-2006" />
                      Add New MDA
                    </span>
                    <ArrowRightIcon size={16} data-id="element-2007" />
                  </button>}
                <button onClick={refreshMdas} className="w-full flex items-center justify-between text-sm px-3 py-2 bg-blue-50 text-blue-700 rounded-md hover:bg-blue-100" data-id="element-2008">
                  <span className="flex items-center" data-id="element-2009">
                    <RefreshCwIcon size={16} className="mr-2" data-id="element-2010" />
                    Refresh Data
                  </span>
                  <ArrowRightIcon size={16} data-id="element-2011" />
                </button>
              </div>
            </div>
          </div>
          {/* MDA Controls */}
          <div className="bg-white rounded-lg shadow mb-6" data-id="element-2012">
            <div className="p-4 border-b border-gray-200" data-id="element-2013">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-2014">
                {/* Search */}
                <div className="relative flex-1" data-id="element-2015">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2016">
                    <SearchIcon size={18} className="text-gray-400" data-id="element-2017" />
                  </div>
                  <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm" placeholder="Search by name, type, sector, or email" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2018" />
                </div>
                {/* Filters */}
                <div className="flex flex-wrap gap-2" data-id="element-2019">
                  <div className="relative" data-id="element-2020">
                    <button className="flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" onClick={() => toggleDropdown('filter')} data-id="element-2021">
                      <FilterIcon size={18} className="mr-2" data-id="element-2022" />
                      Filters
                      <ChevronDownIcon size={18} className="ml-2" data-id="element-2023" />
                    </button>
                    {activeDropdown === 'filter' && <div className="origin-top-right absolute right-0 mt-2 w-72 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10" data-id="element-2024">
                        <div className="py-1 p-3" data-id="element-2025">
                          <div className="mb-3" data-id="element-2026">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2027">
                              Type
                            </label>
                            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm rounded-md" value={typeFilter} onChange={e => setTypeFilter(e.target.value)} data-id="element-2028">
                              <option value="all" data-id="element-2029">All Types</option>
                              {uniqueTypes.map((type, index) => <option key={index} value={type} data-id="element-2030">
                                  {type}
                                </option>)}
                            </select>
                          </div>
                          <div className="mb-3" data-id="element-2031">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2032">
                              Sector
                            </label>
                            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm rounded-md" value={sectorFilter} onChange={e => setSectorFilter(e.target.value)} data-id="element-2033">
                              <option value="all" data-id="element-2034">All Sectors</option>
                              {uniqueSectors.map((sector, index) => <option key={index} value={sector} data-id="element-2035">
                                  {sector}
                                </option>)}
                            </select>
                          </div>
                          <div className="mb-3" data-id="element-2036">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2037">
                              Status
                            </label>
                            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm rounded-md" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-2038">
                              <option value="all" data-id="element-2039">All Statuses</option>
                              <option value="Active" data-id="element-2040">Active</option>
                              <option value="Inactive" data-id="element-2041">Inactive</option>
                              <option value="Under Review" data-id="element-2042">Under Review</option>
                              <option value="Pending Approval" data-id="element-2043">
                                Pending Approval
                              </option>
                            </select>
                          </div>
                          <div className="mb-3" data-id="element-2044">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2045">
                              Sort By
                            </label>
                            <select className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm rounded-md" value={sortOrder} onChange={e => setSortOrder(e.target.value)} data-id="element-2046">
                              <option value="name" data-id="element-2047">Name (A-Z)</option>
                              <option value="name-desc" data-id="element-2048">Name (Z-A)</option>
                              <option value="created" data-id="element-2049">Recently Created</option>
                              <option value="updated" data-id="element-2050">Recently Updated</option>
                              <option value="services" data-id="element-2051">Most Services</option>
                              <option value="revenue" data-id="element-2052">Highest Revenue</option>
                            </select>
                          </div>
                          <div className="flex justify-between pt-2" data-id="element-2053">
                            <button className="text-sm text-gray-700 hover:text-gray-900" onClick={() => {
                          setTypeFilter('all');
                          setSectorFilter('all');
                          setStatusFilter('all');
                          setSortOrder('name');
                        }} data-id="element-2054">
                              Reset Filters
                            </button>
                            <button className="bg-green-600 text-white px-3 py-1 rounded-md text-sm hover:bg-green-700" onClick={() => setActiveDropdown(null)} data-id="element-2055">
                              Apply
                            </button>
                          </div>
                        </div>
                      </div>}
                  </div>
                  <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" onClick={refreshMdas} disabled={isLoading} data-id="element-2056">
                    <RefreshCwIcon size={18} className={`mr-2 ${isLoading ? 'animate-spin' : ''}`} data-id="element-2057" />
                    Refresh
                  </button>
                  {canExportMdas && <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" onClick={exportMdas} data-id="element-2058">
                      <DownloadIcon size={18} className="mr-2" data-id="element-2059" />
                      Export
                    </button>}
                  {canCreateMda && <button className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700" onClick={() => setShowCreateModal(true)} data-id="element-2060">
                      <PlusIcon size={18} className="mr-2" data-id="element-2061" />
                      Add MDA
                    </button>}
                </div>
              </div>
            </div>
          </div>
          {/* MDA Content */}
          <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-2062">
            {filteredMdas.length === 0 ? <div className="p-8 text-center" data-id="element-2063">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100" data-id="element-2064">
                  <BuildingIcon size={24} className="text-gray-400" data-id="element-2065" />
                </div>
                <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-2066">
                  No MDAs found
                </h3>
                <p className="mt-1 text-sm text-gray-500" data-id="element-2067">
                  {searchQuery ? 'Try adjusting your search or filter criteria.' : 'There are no MDAs matching your current filters.'}
                </p>
                <div className="mt-6" data-id="element-2068">
                  <button type="button" className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500" onClick={refreshMdas} data-id="element-2069">
                    <RefreshCwIcon size={16} className="mr-2" data-id="element-2070" />
                    Refresh
                  </button>
                </div>
              </div> : <div className="flex flex-col md:flex-row h-full" data-id="element-2071">
                {/* MDA List */}
                <div className={`w-full md:w-1/2 lg:w-2/3 ${selectedMda ? 'hidden md:block' : ''}`} data-id="element-2072">
                  <div className="overflow-x-auto" data-id="element-2073">
                    <table className="min-w-full divide-y divide-gray-200" data-id="element-2074">
                      <thead className="bg-gray-50" data-id="element-2075">
                        <tr data-id="element-2076">
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2077">
                            MDA
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2078">
                            Type/Sector
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2079">
                            Status
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2080">
                            Services
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2081">
                            Revenue
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2082">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200" data-id="element-2083">
                        {currentItems.map(mda => <tr key={mda.id} className={`hover:bg-gray-50 cursor-pointer ${selectedMda === mda.id ? 'bg-green-50' : ''}`} onClick={() => viewMdaDetails(mda.id)} data-id="element-2084">
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-2085">
                              <div className="flex items-center" data-id="element-2086">
                                <div className="flex-shrink-0 h-10 w-10 rounded-full overflow-hidden" data-id="element-2087">
                                  <img src={mda.logo} alt={mda.name} className="h-10 w-10 object-cover" data-id="element-2088" />
                                </div>
                                <div className="ml-4" data-id="element-2089">
                                  <div className="text-sm font-medium text-gray-900" data-id="element-2090">
                                    {mda.name}
                                  </div>
                                  <div className="text-sm text-gray-500" data-id="element-2091">
                                    {mda.contactInfo.email}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-2092">
                              <div className="text-sm text-gray-900" data-id="element-2093">
                                {mda.type}
                              </div>
                              <div className="text-sm text-gray-500" data-id="element-2094">
                                {mda.sector}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-2095">
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadgeClass(mda.status)}`} data-id="element-2096">
                                {getStatusIcon(mda.status)}
                                <span className="ml-1" data-id="element-2097">{mda.status}</span>
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-2098">
                              <div className="text-sm text-gray-900" data-id="element-2099">
                                {mda.serviceCount}
                              </div>
                              <div className="text-sm text-gray-500" data-id="element-2100">
                                {formatGrowth(mda.serviceGrowth)}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-2101">
                              <div className="text-sm text-gray-900" data-id="element-2102">
                                {formatCurrency(mda.revenue)}
                              </div>
                              <div className="text-sm text-gray-500" data-id="element-2103">
                                {formatGrowth(mda.revenueGrowth)}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2104">
                              <div className="flex space-x-2" data-id="element-2105">
                                <button onClick={e => {
                            e.stopPropagation();
                            viewMdaDetails(mda.id);
                          }} className="text-blue-600 hover:text-blue-900" data-id="element-2106">
                                  <EyeIcon size={16} data-id="element-2107" />
                                </button>
                                {canUpdateMda && <button onClick={e => {
                            e.stopPropagation();
                            setMdaToUpdate(mda);
                            setShowUpdateModal(true);
                          }} className="text-green-600 hover:text-green-900" data-id="element-2108">
                                    <EditIcon size={16} data-id="element-2109" />
                                  </button>}
                                {canDeleteMda && <button onClick={e => {
                            e.stopPropagation();
                            deleteMda(mda.id);
                          }} className="text-red-600 hover:text-red-900" data-id="element-2110">
                                    <TrashIcon size={16} data-id="element-2111" />
                                  </button>}
                              </div>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination */}
                  <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" data-id="element-2112">
                    <div className="flex-1 flex justify-between sm:hidden" data-id="element-2113">
                      <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium ${currentPage === 1 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 hover:bg-gray-50'}`} data-id="element-2114">
                        Previous
                      </button>
                      <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} className={`ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium ${currentPage === totalPages ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-700 hover:bg-gray-50'}`} data-id="element-2115">
                        Next
                      </button>
                    </div>
                    <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-2116">
                      <div data-id="element-2117">
                        <p className="text-sm text-gray-700" data-id="element-2118">
                          Showing{' '}
                          <span className="font-medium" data-id="element-2119">
                            {indexOfFirstItem + 1}
                          </span>{' '}
                          to{' '}
                          <span className="font-medium" data-id="element-2120">
                            {Math.min(indexOfLastItem, filteredMdas.length)}
                          </span>{' '}
                          of{' '}
                          <span className="font-medium" data-id="element-2121">
                            {filteredMdas.length}
                          </span>{' '}
                          results
                        </p>
                      </div>
                      <div data-id="element-2122">
                        <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-2123">
                          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 text-sm font-medium ${currentPage === 1 ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-500 hover:bg-gray-50'}`} data-id="element-2124">
                            <span className="sr-only" data-id="element-2125">Previous</span>
                            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-2126" />
                          </button>
                          {/* Page numbers */}
                          {Array.from({
                        length: Math.min(5, totalPages)
                      }, (_, i) => {
                        let pageNumber: number;
                        if (totalPages <= 5) {
                          pageNumber = i + 1;
                        } else if (currentPage <= 3) {
                          pageNumber = i + 1;
                        } else if (currentPage >= totalPages - 2) {
                          pageNumber = totalPages - 4 + i;
                        } else {
                          pageNumber = currentPage - 2 + i;
                        }
                        return <button key={pageNumber} onClick={() => paginate(pageNumber)} className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${currentPage === pageNumber ? 'z-10 bg-green-50 border-green-500 text-green-600' : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'}`} data-id="element-2127">
                                  {pageNumber}
                                </button>;
                      })}
                          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 text-sm font-medium ${currentPage === totalPages ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-500 hover:bg-gray-50'}`} data-id="element-2128">
                            <span className="sr-only" data-id="element-2129">Next</span>
                            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-2130" />
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
                {/* MDA Detail */}
                {selectedMda ? <div className="w-full md:w-1/2 lg:w-1/3 border-l border-gray-200 flex flex-col" data-id="element-2131">
                    {mdas.filter(m => m.id === selectedMda).map(mda => <div key={mda.id} className="flex flex-col h-full" data-id="element-2132">
                          {/* MDA Header */}
                          <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-2133">
                            <div className="flex items-center justify-between mb-2" data-id="element-2134">
                              <button className="md:hidden flex items-center text-gray-500 hover:text-gray-700" onClick={() => setSelectedMda(null)} data-id="element-2135">
                                <ArrowLeftIcon size={16} className="mr-1" data-id="element-2136" />
                                Back
                              </button>
                              <div className="flex space-x-2" data-id="element-2137">
                                {canUpdateMda && <button onClick={() => {
                        setMdaToUpdate(mda);
                        setShowUpdateModal(true);
                      }} className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-md hover:bg-blue-100" data-id="element-2138">
                                    <EditIcon size={14} className="inline mr-1" data-id="element-2139" />
                                    Edit
                                  </button>}
                                <div className="relative" data-id="element-2140">
                                  <button onClick={() => toggleDropdown('mdaActions')} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-2141">
                                    <MoreHorizontalIcon size={14} data-id="element-2142" />
                                  </button>
                                  {activeDropdown === 'mdaActions' && <div className="absolute right-0 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10" data-id="element-2143">
                                      <div className="py-1" data-id="element-2144">
                                        <button className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" onClick={() => {
                              toggleDropdown('mdaActions');
                              // Print functionality would go here
                              alert(`Printing MDA details for ${mda.name}`);
                            }} data-id="element-2145">
                                          <PrinterIcon size={14} className="inline mr-2" data-id="element-2146" />
                                          Print Details
                                        </button>
                                        <button className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" onClick={() => {
                              toggleDropdown('mdaActions');
                              // Share functionality would go here
                              alert(`Sharing MDA details for ${mda.name}`);
                            }} data-id="element-2147">
                                          <Share2Icon size={14} className="inline mr-2" data-id="element-2148" />
                                          Share Details
                                        </button>
                                        {mda.status === 'Active' && <button className="block w-full text-left px-4 py-2 text-sm text-orange-600 hover:bg-orange-50" onClick={() => {
                              toggleDropdown('mdaActions');
                              updateMdaStatus(mda.id, 'Inactive');
                            }} data-id="element-2149">
                                            <XCircleIcon size={14} className="inline mr-2" data-id="element-2150" />
                                            Deactivate MDA
                                          </button>}
                                        {mda.status === 'Inactive' && <button className="block w-full text-left px-4 py-2 text-sm text-green-600 hover:bg-green-50" onClick={() => {
                              toggleDropdown('mdaActions');
                              updateMdaStatus(mda.id, 'Active');
                            }} data-id="element-2151">
                                            <CheckCircleIcon size={14} className="inline mr-2" data-id="element-2152" />
                                            Activate MDA
                                          </button>}
                                        {canDeleteMda && <button className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50" onClick={() => {
                              toggleDropdown('mdaActions');
                              deleteMda(mda.id);
                            }} data-id="element-2153">
                                            <TrashIcon size={14} className="inline mr-2" data-id="element-2154" />
                                            Delete MDA
                                          </button>}
                                      </div>
                                    </div>}
                                </div>
                              </div>
                            </div>
                            <div className="flex items-center" data-id="element-2155">
                              <div className="flex-shrink-0 h-16 w-16 rounded-full overflow-hidden" data-id="element-2156">
                                <img src={mda.logo} alt={mda.name} className="h-16 w-16 object-cover" data-id="element-2157" />
                              </div>
                              <div className="ml-4" data-id="element-2158">
                                <h2 className="text-lg font-medium text-gray-900" data-id="element-2159">
                                  {mda.name}
                                </h2>
                                <div className="flex items-center mt-1" data-id="element-2160">
                                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadgeClass(mda.status)}`} data-id="element-2161">
                                    {getStatusIcon(mda.status)}
                                    <span className="ml-1" data-id="element-2162">{mda.status}</span>
                                  </span>
                                  <span className="ml-2 text-sm text-gray-500" data-id="element-2163">
                                    {mda.type} • {mda.sector}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* MDA Tabs */}
                          <div className="border-b border-gray-200" data-id="element-2164">
                            <nav className="flex -mb-px" data-id="element-2165">
                              <button className={`py-4 px-6 text-center border-b-2 text-sm font-medium ${activeTab === 'overview' ? 'border-green-500 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('overview')} data-id="element-2166">
                                Overview
                              </button>
                              <button className={`py-4 px-6 text-center border-b-2 text-sm font-medium ${activeTab === 'services' ? 'border-green-500 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('services')} data-id="element-2167">
                                Services
                              </button>
                              <button className={`py-4 px-6 text-center border-b-2 text-sm font-medium ${activeTab === 'users' ? 'border-green-500 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('users')} data-id="element-2168">
                                Admins
                              </button>
                              <button className={`py-4 px-6 text-center border-b-2 text-sm font-medium ${activeTab === 'documents' ? 'border-green-500 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('documents')} data-id="element-2169">
                                Docs
                              </button>
                            </nav>
                          </div>
                          {/* MDA Content */}
                          <div className="flex-1 overflow-y-auto p-4" data-id="element-2170">
                            {activeTab === 'overview' && <div className="space-y-6" data-id="element-2171">
                                <div data-id="element-2172">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2173">
                                    MDA Information
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-2174">
                                    <div className="flex justify-between" data-id="element-2175">
                                      <span className="text-sm text-gray-600" data-id="element-2176">
                                        Name
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2177">
                                        {mda.name}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-2178">
                                      <span className="text-sm text-gray-600" data-id="element-2179">
                                        Type
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2180">
                                        {mda.type}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-2181">
                                      <span className="text-sm text-gray-600" data-id="element-2182">
                                        Sector
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2183">
                                        {mda.sector}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-2184">
                                      <span className="text-sm text-gray-600" data-id="element-2185">
                                        Status
                                      </span>
                                      <span className={`text-sm font-medium ${mda.status === 'Active' ? 'text-green-600' : mda.status === 'Inactive' ? 'text-red-600' : 'text-gray-900'}`} data-id="element-2186">
                                        {mda.status}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-2187">
                                      <span className="text-sm text-gray-600" data-id="element-2188">
                                        Created Date
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2189">
                                        {formatDate(mda.createdAt)}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-2190">
                                      <span className="text-sm text-gray-600" data-id="element-2191">
                                        Last Updated
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2192">
                                        {formatDate(mda.lastUpdateAt)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div data-id="element-2193">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2194">
                                    Contact Information
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-2195">
                                    <div className="flex justify-between" data-id="element-2196">
                                      <span className="text-sm text-gray-600" data-id="element-2197">
                                        Email
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2198">
                                        {mda.contactInfo.email}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-2199">
                                      <span className="text-sm text-gray-600" data-id="element-2200">
                                        Phone
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2201">
                                        {mda.contactInfo.phone}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-2202">
                                      <span className="text-sm text-gray-600" data-id="element-2203">
                                        Website
                                      </span>
                                      <a href={mda.contactInfo.website} target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-blue-600 hover:text-blue-800 flex items-center" data-id="element-2204">
                                        {mda.contactInfo.website.replace('https://', '')}
                                        <ExternalLinkIcon size={12} className="ml-1" data-id="element-2205" />
                                      </a>
                                    </div>
                                    <div className="flex justify-between" data-id="element-2206">
                                      <span className="text-sm text-gray-600" data-id="element-2207">
                                        Address
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2208">
                                        {mda.contactInfo.address}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div data-id="element-2209">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2210">
                                    Performance Metrics
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-2211">
                                    <div className="grid grid-cols-2 gap-4" data-id="element-2212">
                                      <div className="p-3 bg-white rounded-lg border border-gray-200" data-id="element-2213">
                                        <div className="flex items-center justify-between mb-1" data-id="element-2214">
                                          <span className="text-xs text-gray-500" data-id="element-2215">
                                            Services
                                          </span>
                                          <span className="text-xs font-medium" data-id="element-2216">
                                            {formatGrowth(mda.serviceGrowth)}
                                          </span>
                                        </div>
                                        <div className="text-lg font-bold text-gray-900" data-id="element-2217">
                                          {mda.serviceCount}
                                        </div>
                                      </div>
                                      <div className="p-3 bg-white rounded-lg border border-gray-200" data-id="element-2218">
                                        <div className="flex items-center justify-between mb-1" data-id="element-2219">
                                          <span className="text-xs text-gray-500" data-id="element-2220">
                                            Users
                                          </span>
                                          <span className="text-xs font-medium" data-id="element-2221">
                                            {formatGrowth(mda.userGrowth)}
                                          </span>
                                        </div>
                                        <div className="text-lg font-bold text-gray-900" data-id="element-2222">
                                          {mda.userCount}
                                        </div>
                                      </div>
                                      <div className="p-3 bg-white rounded-lg border border-gray-200" data-id="element-2223">
                                        <div className="flex items-center justify-between mb-1" data-id="element-2224">
                                          <span className="text-xs text-gray-500" data-id="element-2225">
                                            Revenue
                                          </span>
                                          <span className="text-xs font-medium" data-id="element-2226">
                                            {formatGrowth(mda.revenueGrowth)}
                                          </span>
                                        </div>
                                        <div className="text-lg font-bold text-gray-900" data-id="element-2227">
                                          {formatCurrency(mda.revenue)}
                                        </div>
                                      </div>
                                      <div className="p-3 bg-white rounded-lg border border-gray-200" data-id="element-2228">
                                        <div className="flex items-center justify-between mb-1" data-id="element-2229">
                                          <span className="text-xs text-gray-500" data-id="element-2230">
                                            Admins
                                          </span>
                                          <span className="text-xs font-medium text-gray-500" data-id="element-2231">
                                            Total
                                          </span>
                                        </div>
                                        <div className="text-lg font-bold text-gray-900" data-id="element-2232">
                                          {mda.adminUsers.length}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div data-id="element-2233">
                                  <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2234">
                                    Key Performance Indicators
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-2235">
                                    {mda.kpis.map((kpi, index) => <div key={index} className="flex justify-between items-center" data-id="element-2236">
                                        <div data-id="element-2237">
                                          <span className="text-sm text-gray-600" data-id="element-2238">
                                            {kpi.name}
                                          </span>
                                          <div className="flex items-center mt-1" data-id="element-2239">
                                            <span className="text-sm font-medium text-gray-900" data-id="element-2240">
                                              {kpi.value}
                                            </span>
                                            <span className="text-xs text-gray-500 ml-2" data-id="element-2241">
                                              Target: {kpi.target}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="text-sm" data-id="element-2242">
                                          {formatGrowth(kpi.change)}
                                        </div>
                                      </div>)}
                                  </div>
                                </div>
                              </div>}
                            {activeTab === 'services' && <div className="space-y-4" data-id="element-2243">
                                <div className="flex justify-between items-center" data-id="element-2244">
                                  <h3 className="text-sm font-medium text-gray-700" data-id="element-2245">
                                    Services ({mda.services.length})
                                  </h3>
                                  <button className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-md hover:bg-blue-100" data-id="element-2246">
                                    <PlusIcon size={12} className="inline mr-1" data-id="element-2247" />
                                    Add Service
                                  </button>
                                </div>
                                {mda.services.length > 0 ? <div className="space-y-3" data-id="element-2248">
                                    {mda.services.slice(0, 5).map(service => <div key={service.id} className="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-md hover:bg-gray-50" data-id="element-2249">
                                        <div className="flex items-center" data-id="element-2250">
                                          <div className="p-2 bg-blue-100 rounded-md mr-3" data-id="element-2251">
                                            <LayersIcon size={16} className="text-blue-600" data-id="element-2252" />
                                          </div>
                                          <div data-id="element-2253">
                                            <p className="text-sm font-medium text-gray-900" data-id="element-2254">
                                              {service.name}
                                            </p>
                                            <div className="flex items-center text-xs text-gray-500" data-id="element-2255">
                                              <span className="flex items-center mr-3" data-id="element-2256">
                                                <DollarSignIcon size={12} className="mr-1" data-id="element-2257" />
                                                {formatCurrency(service.fee)}
                                              </span>
                                              <span className="flex items-center" data-id="element-2258">
                                                <ClockIcon size={12} className="mr-1" data-id="element-2259" />
                                                {service.processingTime} days
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex items-center" data-id="element-2260">
                                          <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${service.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-purple-100 text-purple-800'}`} data-id="element-2261">
                                            {service.status}
                                          </span>
                                          <button className="ml-3 text-gray-400 hover:text-gray-600" data-id="element-2262">
                                            <MoreHorizontalIcon size={16} data-id="element-2263" />
                                          </button>
                                        </div>
                                      </div>)}
                                    {mda.services.length > 5 && <button className="w-full text-center text-sm text-green-600 hover:text-green-800 py-2" data-id="element-2264">
                                        View All {mda.services.length} Services
                                      </button>}
                                  </div> : <div className="text-center py-6 bg-gray-50 rounded-lg" data-id="element-2265">
                                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100" data-id="element-2266">
                                      <LayersIcon size={24} className="text-gray-400" data-id="element-2267" />
                                    </div>
                                    <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-2268">
                                      No services
                                    </h3>
                                    <p className="mt-1 text-sm text-gray-500" data-id="element-2269">
                                      This MDA has not added any services yet.
                                    </p>
                                  </div>}
                                <div className="mt-4" data-id="element-2270">
                                  <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-2271">
                                    Service Performance
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-2272">
                                    <div className="flex justify-between items-center" data-id="element-2273">
                                      <span className="text-sm text-gray-600" data-id="element-2274">
                                        Total Applications
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2275">
                                        {mda.services.reduce((sum, service) => sum + service.applications, 0).toLocaleString()}
                                      </span>
                                    </div>
                                    <div className="flex justify-between items-center" data-id="element-2276">
                                      <span className="text-sm text-gray-600" data-id="element-2277">
                                        Total Revenue
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2278">
                                        {formatCurrency(mda.services.reduce((sum, service) => sum + service.revenue, 0))}
                                      </span>
                                    </div>
                                    <div className="flex justify-between items-center" data-id="element-2279">
                                      <span className="text-sm text-gray-600" data-id="element-2280">
                                        Avg. Processing Time
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2281">
                                        {Math.round(mda.services.reduce((sum, service) => sum + service.processingTime, 0) / mda.services.length)}{' '}
                                        days
                                      </span>
                                    </div>
                                    <div className="flex justify-between items-center" data-id="element-2282">
                                      <span className="text-sm text-gray-600" data-id="element-2283">
                                        Active Services
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2284">
                                        {mda.services.filter(s => s.status === 'Active').length}{' '}
                                        of {mda.services.length}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>}
                            {activeTab === 'users' && <div className="space-y-4" data-id="element-2285">
                                <div className="flex justify-between items-center" data-id="element-2286">
                                  <h3 className="text-sm font-medium text-gray-700" data-id="element-2287">
                                    Admin Users ({mda.adminUsers.length})
                                  </h3>
                                  <button className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-md hover:bg-blue-100" data-id="element-2288">
                                    <PlusIcon size={12} className="inline mr-1" data-id="element-2289" />
                                    Add Admin
                                  </button>
                                </div>
                                {mda.adminUsers.length > 0 ? <div className="space-y-3" data-id="element-2290">
                                    {mda.adminUsers.map(user => <div key={user.id} className="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-md hover:bg-gray-50" data-id="element-2291">
                                        <div className="flex items-center" data-id="element-2292">
                                          <div className="p-2 bg-purple-100 rounded-full mr-3" data-id="element-2293">
                                            <UserIcon size={16} className="text-purple-600" data-id="element-2294" />
                                          </div>
                                          <div data-id="element-2295">
                                            <p className="text-sm font-medium text-gray-900" data-id="element-2296">
                                              {user.name}
                                            </p>
                                            <div className="flex items-center text-xs text-gray-500" data-id="element-2297">
                                              <span data-id="element-2298">{user.email}</span>
                                              <span className="mx-2" data-id="element-2299">•</span>
                                              <span className={`${user.role === 'MDA Admin' ? 'text-green-600 font-medium' : 'text-gray-600'}`} data-id="element-2300">
                                                {user.role}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex items-center" data-id="element-2301">
                                          <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${user.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-2302">
                                            {user.status}
                                          </span>
                                          <button className="ml-3 text-gray-400 hover:text-gray-600" data-id="element-2303">
                                            <MoreHorizontalIcon size={16} data-id="element-2304" />
                                          </button>
                                        </div>
                                      </div>)}
                                  </div> : <div className="text-center py-6 bg-gray-50 rounded-lg" data-id="element-2305">
                                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100" data-id="element-2306">
                                      <UsersIcon size={24} className="text-gray-400" data-id="element-2307" />
                                    </div>
                                    <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-2308">
                                      No admin users
                                    </h3>
                                    <p className="mt-1 text-sm text-gray-500" data-id="element-2309">
                                      This MDA has not added any admin users
                                      yet.
                                    </p>
                                  </div>}
                                <div className="mt-4" data-id="element-2310">
                                  <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-2311">
                                    User Activity
                                  </h3>
                                  <div className="bg-gray-50 rounded-lg p-3 space-y-3" data-id="element-2312">
                                    <div className="flex justify-between items-center" data-id="element-2313">
                                      <span className="text-sm text-gray-600" data-id="element-2314">
                                        Last Login
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2315">
                                        {formatDateTime(mda.adminUsers.sort((a, b) => new Date(b.lastLogin).getTime() - new Date(a.lastLogin).getTime())[0]?.lastLogin || mda.lastUpdateAt)}
                                      </span>
                                    </div>
                                    <div className="flex justify-between items-center" data-id="element-2316">
                                      <span className="text-sm text-gray-600" data-id="element-2317">
                                        Active Admins
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2318">
                                        {mda.adminUsers.filter(u => u.status === 'Active').length}{' '}
                                        of {mda.adminUsers.length}
                                      </span>
                                    </div>
                                    <div className="flex justify-between items-center" data-id="element-2319">
                                      <span className="text-sm text-gray-600" data-id="element-2320">
                                        Primary Admin
                                      </span>
                                      <span className="text-sm font-medium text-gray-900" data-id="element-2321">
                                        {mda.adminUsers.find(u => u.role === 'MDA Admin')?.name || 'Not assigned'}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>}
                            {activeTab === 'documents' && <div className="space-y-4" data-id="element-2322">
                                <div className="flex justify-between items-center" data-id="element-2323">
                                  <h3 className="text-sm font-medium text-gray-700" data-id="element-2324">
                                    Documents ({mda.documents.length})
                                  </h3>
                                  <button className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-md hover:bg-blue-100" data-id="element-2325">
                                    <PlusIcon size={12} className="inline mr-1" data-id="element-2326" />
                                    Upload Document
                                  </button>
                                </div>
                                {mda.documents.length > 0 ? <div className="space-y-3" data-id="element-2327">
                                    {mda.documents.map(doc => <div key={doc.id} className="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-md hover:bg-gray-50" data-id="element-2328">
                                        <div className="flex items-center" data-id="element-2329">
                                          <div className="p-2 bg-blue-100 rounded-md mr-3" data-id="element-2330">
                                            <FileIcon size={16} className="text-blue-600" data-id="element-2331" />
                                          </div>
                                          <div data-id="element-2332">
                                            <p className="text-sm font-medium text-gray-900" data-id="element-2333">
                                              {doc.name}
                                            </p>
                                            <p className="text-xs text-gray-500" data-id="element-2334">
                                              {doc.size} • {doc.type} • Uploaded
                                              on {formatDate(doc.uploadedAt)}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="flex space-x-2" data-id="element-2335">
                                          <button className="text-gray-500 hover:text-gray-700" data-id="element-2336">
                                            <EyeIcon size={16} data-id="element-2337" />
                                          </button>
                                          <button className="text-gray-500 hover:text-gray-700" data-id="element-2338">
                                            <DownloadIcon size={16} data-id="element-2339" />
                                          </button>
                                        </div>
                                      </div>)}
                                  </div> : <div className="text-center py-6 bg-gray-50 rounded-lg" data-id="element-2340">
                                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100" data-id="element-2341">
                                      <FileIcon size={24} className="text-gray-400" data-id="element-2342" />
                                    </div>
                                    <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-2343">
                                      No documents
                                    </h3>
                                    <p className="mt-1 text-sm text-gray-500" data-id="element-2344">
                                      No documents have been uploaded for this
                                      MDA.
                                    </p>
                                  </div>}
                                <div className="mt-4" data-id="element-2345">
                                  <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-2346">
                                    Upload New Document
                                  </h3>
                                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center" data-id="element-2347">
                                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100" data-id="element-2348">
                                      <UploadIcon size={24} className="text-gray-400" data-id="element-2349" />
                                    </div>
                                    <p className="mt-2 text-sm text-gray-500" data-id="element-2350">
                                      Drag and drop files here, or
                                      <button className="ml-1 text-green-600 hover:text-green-800 font-medium" data-id="element-2351">
                                        browse
                                      </button>
                                    </p>
                                    <p className="text-xs text-gray-400 mt-1" data-id="element-2352">
                                      PDF, DOCX, XLSX up to 10MB
                                    </p>
                                  </div>
                                </div>
                              </div>}
                          </div>
                          {/* MDA Actions */}
                          <div className="p-4 border-t border-gray-200 bg-gray-50" data-id="element-2353">
                            <div className="flex flex-wrap gap-2" data-id="element-2354">
                              {mda.status === 'Inactive' && <button onClick={() => updateMdaStatus(mda.id, 'Active')} className="flex-1 flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700" data-id="element-2355">
                                  <CheckCircleIcon size={16} className="mr-2" data-id="element-2356" />
                                  Activate
                                </button>}
                              {mda.status === 'Active' && <button onClick={() => updateMdaStatus(mda.id, 'Inactive')} className="flex-1 flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-orange-600 hover:bg-orange-700" data-id="element-2357">
                                  <XCircleIcon size={16} className="mr-2" data-id="element-2358" />
                                  Deactivate
                                </button>}
                              {mda.status === 'Pending Approval' && <>
                                  <button onClick={() => updateMdaStatus(mda.id, 'Active')} className="flex-1 flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700" data-id="element-2359">
                                    <CheckCircleIcon size={16} className="mr-2" data-id="element-2360" />
                                    Approve
                                  </button>
                                  <button onClick={() => updateMdaStatus(mda.id, 'Inactive')} className="flex-1 flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-2361">
                                    <XCircleIcon size={16} className="mr-2" data-id="element-2362" />
                                    Reject
                                  </button>
                                </>}
                              <button className="flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" onClick={() => {
                      window.open(mda.contactInfo.website, '_blank');
                    }} data-id="element-2363">
                                <GlobeIcon size={16} className="mr-2" data-id="element-2364" />
                                Visit Website
                              </button>
                            </div>
                          </div>
                        </div>)}
                  </div> : <div className="hidden md:flex md:w-1/2 lg:w-1/3 border-l border-gray-200 items-center justify-center p-8 bg-gray-50" data-id="element-2365">
                    <div className="text-center" data-id="element-2366">
                      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100" data-id="element-2367">
                        <BuildingIcon size={24} className="text-gray-400" data-id="element-2368" />
                      </div>
                      <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-2369">
                        No MDA selected
                      </h3>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-2370">
                        Select an MDA from the list to view details.
                      </p>
                    </div>
                  </div>}
              </div>}
          </div>
          {/* Help & Resources */}
          <div className="bg-white rounded-lg shadow p-4 mt-6" data-id="element-2371">
            <div className="flex justify-between items-center mb-4" data-id="element-2372">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-2373">
                MDA Management Resources
              </h3>
              <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-2374">
                <MoreHorizontalIcon size={14} data-id="element-2375" />
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-2376">
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2377">
                <div className="flex items-start" data-id="element-2378">
                  <div className="p-2 bg-blue-100 rounded-md mr-3" data-id="element-2379">
                    <ClipboardIcon size={20} className="text-blue-600" data-id="element-2380" />
                  </div>
                  <div data-id="element-2381">
                    <h4 className="text-sm font-medium text-gray-900 mb-1" data-id="element-2382">
                      MDA Onboarding Guide
                    </h4>
                    <p className="text-xs text-gray-600 mb-2" data-id="element-2383">
                      Learn about the process for adding new MDAs to the
                      platform and setting them up for success.
                    </p>
                    <a href="#" className="text-xs text-blue-600 hover:text-blue-800 flex items-center" data-id="element-2384">
                      View Guide
                      <ArrowRightIcon size={14} className="ml-1" data-id="element-2385" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2386">
                <div className="flex items-start" data-id="element-2387">
                  <div className="p-2 bg-purple-100 rounded-md mr-3" data-id="element-2388">
                    <FileTextIcon size={20} className="text-purple-600" data-id="element-2389" />
                  </div>
                  <div data-id="element-2390">
                    <h4 className="text-sm font-medium text-gray-900 mb-1" data-id="element-2391">
                      MDA Performance Metrics
                    </h4>
                    <p className="text-xs text-gray-600 mb-2" data-id="element-2392">
                      Understand how to measure and improve MDA performance
                      using our analytics tools.
                    </p>
                    <a href="#" className="text-xs text-purple-600 hover:text-purple-800 flex items-center" data-id="element-2393">
                      View Metrics
                      <ArrowRightIcon size={14} className="ml-1" data-id="element-2394" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2395">
                <div className="flex items-start" data-id="element-2396">
                  <div className="p-2 bg-green-100 rounded-md mr-3" data-id="element-2397">
                    <HelpCircleIcon size={20} className="text-green-600" data-id="element-2398" />
                  </div>
                  <div data-id="element-2399">
                    <h4 className="text-sm font-medium text-gray-900 mb-1" data-id="element-2400">
                      MDA Admin Training
                    </h4>
                    <p className="text-xs text-gray-600 mb-2" data-id="element-2401">
                      Access training materials for MDA administrators to help
                      them manage their services effectively.
                    </p>
                    <a href="#" className="text-xs text-green-600 hover:text-green-800 flex items-center" data-id="element-2402">
                      View Training
                      <ArrowRightIcon size={14} className="ml-1" data-id="element-2403" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 p-4 text-center text-sm text-gray-600" data-id="element-2404">
          <p data-id="element-2405">Edo State Government Admin Portal © 2025</p>
          <p className="mt-1" data-id="element-2406">Powered by Edo ICT Agency</p>
        </footer>
      </div>
      {/* Delete MDA Modal */}
      {showDeleteModal && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-2407">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full" data-id="element-2408">
            <div className="px-6 py-4 border-b border-gray-200" data-id="element-2409">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-2410">Delete MDA</h3>
            </div>
            <div className="p-6" data-id="element-2411">
              <div className="mb-4" data-id="element-2412">
                <div className="flex items-center mb-4" data-id="element-2413">
                  <div className="flex-shrink-0 bg-red-100 rounded-full p-2 mr-3" data-id="element-2414">
                    <AlertTriangleIcon size={24} className="text-red-600" data-id="element-2415" />
                  </div>
                  <div data-id="element-2416">
                    <h3 className="text-sm font-medium text-gray-900" data-id="element-2417">
                      Are you sure you want to delete this MDA?
                    </h3>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-2418">
                      This action cannot be undone. All data associated with
                      this MDA including services, users, and applications will
                      be permanently removed.
                    </p>
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-2419">
                  <p className="text-sm text-gray-700 mb-2" data-id="element-2420">
                    <span className="font-medium" data-id="element-2421">MDA:</span>{' '}
                    {mdas.find(m => m.id === mdaToDelete)?.name}
                  </p>
                  <p className="text-sm text-gray-700 mb-2" data-id="element-2422">
                    <span className="font-medium" data-id="element-2423">Type:</span>{' '}
                    {mdas.find(m => m.id === mdaToDelete)?.type}
                  </p>
                  <p className="text-sm text-gray-700 mb-2" data-id="element-2424">
                    <span className="font-medium" data-id="element-2425">Sector:</span>{' '}
                    {mdas.find(m => m.id === mdaToDelete)?.sector}
                  </p>
                  <p className="text-sm text-gray-700" data-id="element-2426">
                    <span className="font-medium" data-id="element-2427">Status:</span>{' '}
                    {mdas.find(m => m.id === mdaToDelete)?.status}
                  </p>
                </div>
                <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-md" data-id="element-2428">
                  <p className="text-sm text-yellow-800" data-id="element-2429">
                    <AlertCircleIcon size={16} className="inline mr-2" data-id="element-2430" />
                    This MDA has{' '}
                    {mdas.find(m => m.id === mdaToDelete)?.serviceCount || 0}{' '}
                    services and{' '}
                    {mdas.find(m => m.id === mdaToDelete)?.adminUsers.length || 0}{' '}
                    admin users that will also be deleted.
                  </p>
                </div>
              </div>
            </div>
            <div className="px-6 py-3 border-t border-gray-200 flex justify-end space-x-3" data-id="element-2431">
              <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-2432">
                Cancel
              </button>
              <button onClick={processDelete} disabled={isProcessing} className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-2433">
                {isProcessing ? <>
                    <RefreshCwIcon size={16} className="inline mr-2 animate-spin" data-id="element-2434" />
                    Processing...
                  </> : 'Delete MDA'}
              </button>
            </div>
          </div>
        </div>}
      {/* Create MDA Modal would go here */}
      {/* Update MDA Modal would go here */}
    </div>;
};
export default MDAManagement;